import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import { FaUserCircle, FaCalendarAlt } from "react-icons/fa";
import "./BlogDetails.css";
import { BACKEND_URL } from "../../../config";

const toSlug = (str = "") =>
  str.toLowerCase().trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");

function BlogDetails() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [faqList, setFaqList] = useState([]);
  const [openFaq, setOpenFaq] = useState(0); // first FAQ open by default

  useEffect(() => {
    setDataLoaded(false);

    const fetchBlog = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api.php?module=blog`);
        const data = await res.json();

        if (data.success) {
          const all = Array.isArray(data.data) ? data.data : [];
          const matched = all.find((b) => toSlug(b.title) === slug) || null;
          setBlog(matched);
        if (matched?.faq) {
        try {
          setFaqList(JSON.parse(matched.faq));
        } catch {
          setFaqList([]);
        }
      } else {
        setFaqList([]);
      }
        } else {
          setBlog(null);
        }
      } catch (error) {
        console.log(error);
        setBlog(null);
      } finally {
        setDataLoaded(true);
      }
    };

    fetchBlog();
  }, [slug]);

  if (!dataLoaded) return null;

  if (!blog) {
    return (
      <main>
        <h2 className="loading">Blog Not Found</h2>
      </main>
    );
  }

  return (
    <main>

      <Helmet>
        <title>
          {blog.title ? `${blog.title} | realgeneric shop` : "realgeneric shop"}
        </title>
        <meta
          name="description"
          content={
            blog.description
              ? blog.description.replace(/<[^>]+>/g, "").substring(0, 160)
              : ""
          }
        />
        <meta
          name="keywords"
          content={`realgeneric shop, ${blog.title || "blog"}, healthcare, medicine guide`}
        />
         <meta property="og:title" content={blog.title || "Blog"} />
          <link rel="canonical" href={`https://realgenericshop.com/blog/${slug}`} />
      </Helmet>

      <h1 className="blog-title">{blog.title}</h1>

      <section className="author-section">
        <FaUserCircle className="icon" />
        <section className="author-details">
          <h4 className="author-name">
            Written by {blog.author || "Admin"}
          </h4>
          <p className="date">
            <FaCalendarAlt className="date-icon" />
            {blog.date || blog.created_at || "Published Recently"}
          </p>
        </section>
      </section>

      <img
        src={
          blog.image?.startsWith("http")
            ? blog.image
            : `${BACKEND_URL}/${blog.image}`
        }
        alt={blog.title}
        className="image"
      />

      <section
        className="description"
        dangerouslySetInnerHTML={{ __html: blog.description }}
      />

    {faqList.length > 0 && (

  <section className="blog-faq">

    <h2 className="faq-heading">
      Frequently Asked Questions
    </h2>

    {faqList.map((item, index) => (

      <div
        key={index}
        className={`faq-item ${openFaq === index ? "active" : ""}`}
      >

        <button
          className="faq-question"
          onClick={() =>
            setOpenFaq(
              openFaq === index ? -1 : index
            )
          }
        >

          <span>{item.question}</span>

          <span className="faq-icon">
            {openFaq === index ? "^" : "v"}
          </span>

        </button>

        <div
          className={`faq-answer ${
            openFaq === index ? "show" : ""
          }`}
        >

          <p>{item.answer}</p>

        </div>

      </div>

    ))}

  </section>


)}
    </main>
  );
}

export default BlogDetails;